import {request} from '@/utils/request'

// 用户 - 列表
// export function getUserList(data) {
//   return request('GET', '/user', data, true)
// }
export function getUserList(data) {
  return request('GET', '/user/page', data, true)
}

// 用户 - 添加
export function postUserAdd(data) {
  return request('POST', '/user', data, true)
}



// 用户 - 详情
// export function getUserInfo(data) {
//   return request('GET', '/user/edit', data, true)
// }

export function getUserInfo(id,data) {
  return request('GET', 'user/'+id, data, true)
}
// 用户 - 编辑
// export function postUserEdit(data) {
//   return request('POST', '/user/edit', data, true)
// }
export function postUserEdit(data) {
  return request('PUT', '/user', data, true)
}
// 用户 - 删除

// export function postUserDel(data) {
//   return request('POST', '/user/del', data, true)
// }
export function postUserDel(id,data) {
  return request('DELETE', '/user/'+id, data, true)
}




// 角色 - 列表

// export function getUserRoleList(data) {
//   return request('GET', '/role', data, true)
// }
export function getUserRoleList(data) {
  return request('GET', '/sys-role/page', data, true)
}

// 角色 - 添加

// export function postUserRoleAdd(data) {
//   return request('POST', '/role/add', data, true)
// }
export function postUserRoleAdd(data) {
  return request('POST', '/sys-role', data, true)
}

// 角色 - 编辑

// export function postUserRoleEdit(data) {
//   return request('POST', '/role/edit', data, true)
// }
export function postUserRoleEdit(data) {
  return request('PUT', '/sys-role', data, true)
}

// 角色 - 删除

// export function postUserRoleDel(data) {
//   return request('POST', '/role/del', data, true)
// }
export function postUserRoleDel(id,data) {
  return request('DELETE', '/sys-role/'+id, data, true)
}


// 角色 - 关联功能
export function getUserRoleFeatures(data) {
  return request('GET', '/role/modules', data, true)
}

// 角色 - 关联功能 - 编辑
export function postUserRoleFeaturesEdit(data) {
  return request('POST', 'api/role/modules/edit', data, true)
}

// 所有功能
// export function getModulesList(data) {
//   return request('POST', '/modules/all', data, true)
// }

export function getModulesList(data) {
  return request('POST', '/modules/all', data, true)
}

//   权限
export function putUserList(data) {
  return request('PUT', '/sys-role/bind/menu', data, true)
}

//  菜单栏
export function getIndexList(data) {
  return request('GET', '/sys-role/bind/menu', data, true)
}
//  菜单栏
export function getRoleList(id,data) {
  return request('GET', '/sys-role/'+id, data, true)
}

//  用户列表
export function getUserAll(data) {
  return request('GET', '/user/list', data, true)
}